import React from 'react';

const FormLabelUi = ({ text, textColor }) => {
  return <span className={textColor ?? 'text-labelColor'}>{text}</span>;
};

export default FormLabelUi;
